// dcd-help-block.js — "Not sure what to order?" help CTA on product + collection pages.
// Phase 2.3 launch cleanup. Idempotent: checks for existing #dcd-help-block.
//
// Update (May 22 2026): on collection pages, after the blue help block is
// injected before .collection-wrapper, we also relocate the
// sfk_coll_categories section so the visual order is:
//   Hero → Blue help block → COLLECTION category grid → Products.
(() => {
  if (document.getElementById('dcd-help-block')) return;

  const CSS = `
    #dcd-help-block {
      max-width: 1640px;
      margin: 18px auto 24px;
      padding: 22px 24px;
      background: #0F2A44;
      color: #fff;
      border-radius: 14px;
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      gap: 18px;
      font-family: inherit;
    }
    #dcd-help-block .dcd-help-block__text { line-height: 1.55; }
    #dcd-help-block .dcd-help-block__h {
      color: #fff; font-size: 1.15rem; font-weight: 700; margin: 0 0 6px;
      letter-spacing: -0.005em;
    }
    #dcd-help-block p {
      margin: 0; color: rgba(255,255,255,0.88); font-size: 0.95rem;
    }
    #dcd-help-block .dcd-help-block__ctas {
      display: flex; gap: 10px; flex-wrap: wrap;
    }
    #dcd-help-block .dcd-help-block__btn {
      display: inline-flex; align-items: center; gap: 6px;
      padding: 11px 18px; border-radius: 999px;
      font-size: 0.9rem; font-weight: 600; text-decoration: none;
      white-space: nowrap;
    }
    #dcd-help-block .dcd-help-block__btn--primary { background: #E76F2A; color: #fff; }
    #dcd-help-block .dcd-help-block__btn--primary:hover { background: #cc5f20; }
    #dcd-help-block .dcd-help-block__btn--ghost { background: transparent; color: #fff; border: 1px solid rgba(255,255,255,0.7); }
    #dcd-help-block .dcd-help-block__btn--ghost:hover { background: rgba(255,255,255,0.1); }
    @media (max-width: 720px) {
      #dcd-help-block { grid-template-columns: 1fr; padding: 18px 18px; margin: 14px 12px 18px; }
      #dcd-help-block .dcd-help-block__ctas { width: 100%; }
      #dcd-help-block .dcd-help-block__btn { flex: 1; justify-content: center; }
    }
  `;
  const HTML = `
    <div class="dcd-help-block__text">
      <div class="dcd-help-block__h">Not sure what cabinets or parts you need?</div>
      <p>Cabinet orders can include base cabinets, wall cabinets, tall cabinets, fillers, panels, moldings, trim, toe kicks, finished ends, and accessories. Send us your measurements and we'll help build the correct cabinet list before you buy.</p>
    </div>
    <div class="dcd-help-block__ctas">
      <a class="dcd-help-block__btn dcd-help-block__btn--primary" href="/pages/free-3d-kitchen-design">Start Free 3D Design</a>
      <a class="dcd-help-block__btn dcd-help-block__btn--ghost" href="/pages/contact">Contact Us</a>
    </div>
  `;
  const node = document.createElement('div');
  node.id = 'dcd-help-block';
  node.innerHTML = HTML;
  const style = document.createElement('style');
  style.id = 'dcd-help-block-css';
  style.textContent = CSS;
  if (!document.getElementById('dcd-help-block-css')) document.head.appendChild(style);

  function isCollectionPage() {
    return /\/collections\//.test(location.pathname) && !/\/products\//.test(location.pathname);
  }
  function isProductPage() { return /\/products\//.test(location.pathname); }

  function place() {
    if (isProductPage()) {
      const target = document.querySelector('.product-information');
      if (target && target.parentNode) {
        target.parentNode.insertBefore(node, target.nextSibling);
        return;
      }
      const main = document.querySelector('main') || document.body;
      main.appendChild(node);
      return;
    }

    if (isCollectionPage()) {
      const target = document.querySelector('.collection-wrapper, .main-collection-grid');
      if (target && target.parentNode) {
        target.parentNode.insertBefore(node, target);

        // Relocate the COLLECTION category grid section to sit right after the
        // blue help block. The section template puts it ABOVE `main`, but the
        // user wants it BELOW the blue help block.
        const catsSec = document.querySelector('[id*="sfk_coll_categories"]');
        if (catsSec && node.parentNode) {
          node.parentNode.insertBefore(catsSec, node.nextSibling);
        }
        // The collection description (sfk_coll_desc) also moves below the blue
        // help block so the hero shows only the title. Final order:
        //   Hero -> Blue help block -> description -> COLLECTION category grid -> Products.
        const descSec = document.querySelector('[id*="sfk_coll_desc"]');
        if (descSec && node.parentNode) {
          node.parentNode.insertBefore(descSec, node.nextSibling);
        }
        return;
      }
      const main = document.querySelector('main') || document.body;
      main.insertBefore(node, main.firstChild);
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place, { once: true });
  } else {
    place();
  }
})();

// DCD_RELATED_LINKS_START — SEO #3 internal linking
(() => {
  if (!/\/products\//.test(location.pathname)) return;
  if (document.getElementById("dcd-related-links")) return;

  var SUFFIX_TO_FAMILY = {"cloud-white":"color-white","frost":"color-white","blanco":"color-white","blanco-gloss":"color-white","bianco-matte":"color-white","bionco-gloss":"color-white","hallmark":"color-white","dove":"color-dove","linen":"color-dove","textil-plata":"color-gray","gris-plomo":"color-gray","gris-nube":"color-gray","metallo-1":"color-gray","metallo-4":"color-gray","smoky-grey":"color-gray","kona":"color-gray","nickel":"color-gray","stone":"color-gray","horizon":"color-gray","basalto":"color-gray","grigio-gloss":"color-gray","mist":"color-gray","carbone-matte":"color-gray","mocha":"color-brown","canyon-oak":"color-brown","rosales-3":"color-brown","nocce-4":"color-brown","ida-1":"color-brown","ida-2":"color-brown","frappe":"color-brown","woodline-1":"color-brown","woodline-3":"color-brown","woodline-4":"color-brown","como-ash-1":"color-brown","olivo":"color-brown","guayana":"color-brown","macadamia-beige":"color-brown","ice-cream":"color-brown","cashmere":"color-brown","cashmere-gloss":"color-brown","muratti-1":"color-brown","muratti-4":"color-brown","olmo-3":"color-brown","java":"color-brown","oyster":"color-brown","graphite-black":"color-black","pitch-black":"color-black","black-onyx":"color-black","black-gloss":"color-black","ebony":"color-black","antracita":"color-black","euroline-gloss":"color-black","izel-blue":"color-blue","denim-blue":"color-blue","azul-marino":"color-blue","azul-indigo":"color-blue","azul-marino-gloss":"color-blue","azul-indigo-gloss":"color-blue","aria-blue":"color-blue","marine":"color-blue","indigo":"color-blue","mint-green":"color-green","forest-green":"color-green","pistachio-green":"color-green","hunter-green":"color-green","sage-green":"color-green","verde-salvia":"color-green","agua-marina":"color-green","agua-marina-gloss":"color-green","desert-oak":"color-natural","sandy-mirage":"color-natural","unfinished":"color-natural","timber":"color-natural","truffle":"color-natural","como-ash-2":"color-natural","nocce-1":"color-natural","nocce-3":"color-natural","rosales-1":"color-natural","rosales-2":"color-natural","toffee":"color-natural","cabernet-red":"color-red","rosales":"color-red","orchid-purple":"color-purple"};
  var SPECIAL_CASES = {"fabuwood-illume-catalina-black":"color-black"};

  // Style detection: ordered, more-specific first.
  var STYLE_RULES = [
    { match: /-luxe-/,      page: "/pages/style-slab",         label: "Slab Door Cabinets" },
    { match: /-catalina-/,  page: "/pages/style-slab",         label: "Slab Door Cabinets" },
    { match: /-avalon-/,    page: "/pages/style-raised-panel", label: "Raised Panel Cabinets" },
    { match: /-charlton-/,  page: "/pages/style-raised-panel", label: "Raised Panel Cabinets" },
    { match: /-perla-/,     page: "/pages/style-raised-panel", label: "Raised Panel Cabinets" },
    { match: /-frameless-/, page: "/pages/style-frameless",    label: "Frameless Cabinets" },
    { match: /-galaxy-/,    page: "/pages/style-shaker",       label: "Shaker Cabinets" },
    { match: /-onyx-/,      page: "/pages/style-shaker",       label: "Shaker Cabinets" },
    { match: /-nexus-/,     page: "/pages/style-shaker",       label: "Shaker Cabinets" },
    { match: /-luna-/,      page: "/pages/style-shaker",       label: "Shaker Cabinets" },
    { match: /-imperio-/,   page: "/pages/style-shaker",       label: "Shaker Cabinets" },
    { match: /shaker/,      page: "/pages/style-shaker",       label: "Shaker Cabinets" }
  ];

  var LINE_RULES = [
    { match: /fabuwood-allure-/,        page: "/pages/fabuwood-allure-cabinets",        label: "Fabuwood Allure Cabinets" },
    { match: /fabuwood-illume-/,        page: "/pages/fabuwood-illume-cabinets",        label: "Fabuwood Illume Cabinets" },
    { match: /fabuwood-quest-/,         page: "/pages/fabuwood-quest-cabinets",         label: "Fabuwood Quest Cabinets" },
    { match: /fabuwood-value-premium-/, page: "/pages/fabuwood-value-premium-cabinets", label: "Fabuwood Value Premium Cabinets" },
    { match: /^fabuwood-/,              page: "/pages/fabuwood-cabinets",               label: "Fabuwood Cabinets" },
    { match: /^jarlin-/,                page: "/pages/jarlin-cabinets",                 label: "Jarlin Cabinets" }
  ];

  var FAMILY_LABELS = {
    "color-white": "White Cabinets",
    "color-dove": "Dove Cabinets",
    "color-gray": "Gray Cabinets",
    "color-brown": "Brown Cabinets",
    "color-black": "Black Cabinets",
    "color-blue": "Blue Cabinets",
    "color-green": "Green Cabinets",
    "color-natural": "Natural Wood Cabinets",
    "color-red": "Red Cabinets",
    "color-purple": "Purple Cabinets",
    "color-specialty": "Specialty Finishes"
  };

  function extractHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1].toLowerCase() : "";
  }

  function detectLine(handle) {
    for (var i = 0; i < LINE_RULES.length; i++) {
      if (LINE_RULES[i].match.test(handle)) return LINE_RULES[i];
    }
    return null;
  }

  function detectStyle(handle) {
    for (var i = 0; i < STYLE_RULES.length; i++) {
      if (STYLE_RULES[i].match.test(handle)) return STYLE_RULES[i];
    }
    return null;
  }

  function detectColorFamily(handle) {
    for (var key in SPECIAL_CASES) {
      if (handle === key || handle.indexOf(key + "-") === 0 || handle.indexOf(key) === 0) {
        return SPECIAL_CASES[key];
      }
    }
    var keys = Object.keys(SUFFIX_TO_FAMILY).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var suffix = keys[i];
      if (handle === suffix) return SUFFIX_TO_FAMILY[suffix];
      if (handle.length > suffix.length && handle.lastIndexOf("-" + suffix) === handle.length - suffix.length - 1) {
        return SUFFIX_TO_FAMILY[suffix];
      }
      if (handle.indexOf("-" + suffix + "-") >= 0) return SUFFIX_TO_FAMILY[suffix];
    }
    return null;
  }

  var handle = extractHandle();
  if (!handle) return;

  var line = detectLine(handle);
  var style = detectStyle(handle);
  var family = detectColorFamily(handle);

  var links = [];
  var seen = {};
  function add(href, label) {
    if (!href || seen[href]) return;
    seen[href] = true;
    links.push({ href: href, label: label });
  }
  if (line) add(line.page, line.label);
  if (style) add(style.page, style.label);
  if (family) add("/pages/" + family, FAMILY_LABELS[family] || "Cabinets");
  add("/collections/door-samples", "Order Door Samples");

  if (links.length < 2) return;

  var CSS = [
    "#dcd-related-links {",
    "  max-width: 1640px; margin: 18px auto 24px; padding: 18px 24px;",
    "  background: #faf8f4; border: 1px solid #e7e2d8; border-radius: 12px;",
    "  font-family: inherit;",
    "}",
    "#dcd-related-links .dcd-rl-h {",
    "  font-size: 0.95rem; font-weight: 700; text-transform: uppercase;",
    "  letter-spacing: 0.04em; color: #0F2A44; margin: 0 0 12px;",
    "}",
    "#dcd-related-links ul {",
    "  list-style: none; padding: 0; margin: 0;",
    "  display: flex; flex-wrap: wrap; gap: 8px 10px;",
    "}",
    "#dcd-related-links li { margin: 0; }",
    "#dcd-related-links a {",
    "  display: inline-block; padding: 8px 14px; background: #fff;",
    "  border: 1px solid #d8d2c4; border-radius: 999px;",
    "  color: #0F2A44; text-decoration: none;",
    "  font-size: 0.88rem; font-weight: 500;",
    "  transition: border-color 0.15s, background 0.15s;",
    "}",
    "#dcd-related-links a:hover { background: #0F2A44; color: #fff; border-color: #0F2A44; }",
    "@media (max-width: 720px) {",
    "  #dcd-related-links { margin: 14px 12px 18px; padding: 14px 16px; }",
    "  #dcd-related-links a { font-size: 0.85rem; padding: 7px 12px; }",
    "}"
  ].join("\n");

  var ulHtml = "";
  for (var i = 0; i < links.length; i++) {
    ulHtml += "<li><a href=\"" + links[i].href + "\">" + links[i].label + "</a></li>";
  }

  var node = document.createElement("section");
  node.id = "dcd-related-links";
  node.innerHTML = "<p class=\"dcd-rl-h\">Also Explore</p><ul>" + ulHtml + "</ul>";

  if (!document.getElementById("dcd-related-links-css")) {
    var st = document.createElement("style");
    st.id = "dcd-related-links-css";
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function place() {
    if (document.getElementById("dcd-related-links")) return;
    var help = document.getElementById("dcd-help-block");
    // 2026-10-16 (audit #4): on 10x10 set pages the help block is server-rendered ABOVE the product, so placing the links
    // after it pushed the whole product down after load (CLS 0.03). There, put them below the product instead.
    if (help && help.parentNode && !help.closest(".dcd-set-help")) { help.parentNode.insertBefore(node, help.nextSibling); return; }
    var target = document.querySelector(".product-information");
    if (target && target.parentNode) { target.parentNode.insertBefore(node, target.nextSibling); return; }
    var main = document.querySelector("main") || document.body;
    main.appendChild(node);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { setTimeout(place, 50); }, { once: true });
  } else {
    setTimeout(place, 50);
  }
})();
// DCD_RELATED_LINKS_END
